/**
 * EventConfig
 * 
 * Centralized event names for the entire game.
 * Replaces legacy events.json.
 */

export const EVENT_CONFIG = {
  map: {
    change: 'change_map',
    teleport: 'teleport',
    spawn: 'spawn'
  },
  combat: {
    damage: 'Combat.Damage',
    death: 'Combat.Death',
    heal: 'Combat.Heal'
  },
  character: {
    created: 'Hero.Created',
    levelUp: 'Character.LevelUp',
    statChange: 'Character.StatChange'
  },
  inventory: {
    itemAdded: 'Inventory.ItemAdded',
    itemRemoved: 'Inventory.ItemRemoved',
    equipmentChanged: 'Inventory.EquipmentChanged'
  },
  quest: {
    accepted: 'Quest.Accepted',
    completed: 'Quest.Completed',
    progressUpdated: 'Quest.ProgressUpdated'
  },
  ui: {
    windowOpened: 'UI.WindowOpened',
    windowClosed: 'UI.WindowClosed',
    notification: 'UI.Notification'
  }
} as const;
